import { ComponentModelDTO, GroopItModel_V1 } from "groopit-js";
import React, { Fragment, useState } from "react";
import { GroopitComponentEditor } from "./GroopitComponentEditor";
import {
  ComponentDataDTO,
  FollowUpEditorResponseDTO,
  ModelStateErrorDTO,
  UserDTO,
} from "groopit-js/client";
import { SalesforceEditAuthenticator } from "./SalesforceEditAuthenticator";

interface FollowUpComponentEditorProps {
  groupId: string;
  groopItId: string;
  componentModels: ComponentModelDTO[];
  componentDatas: ComponentDataDTO[];
  tags: { [id: string]: UserDTO };
  isLinkedToSalesforce: boolean;
  onGroopitUpdated: (groopit: GroopItModel_V1) => void;
  onClose: () => void;
}

export const FollowUpComponentEditor = (
  props: FollowUpComponentEditorProps,
) => {
  const {
    groupId,
    groopItId,
    componentModels,
    componentDatas,
    tags,
    isLinkedToSalesforce,
    onGroopitUpdated,
    onClose,
  } = { ...props };
  const [errors, setErrors] = useState<ModelStateErrorDTO>();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    formData.append(
      "__RequestVerificationToken",
      (
        document.getElementsByName(
          "__RequestVerificationToken",
        )[0] as HTMLInputElement
      ).value,
    );
    fetch(`/groopit/${groopItId}/followup`, {
      method: "PUT",
      body: formData,
    })
      .then((response) => response.json())
      .then((json) => FollowUpEditorResponseDTO.fromJS(json))
      .then((followUpResponse) => {
        if (followUpResponse.success && followUpResponse.groopit) {
          setErrors(undefined);
          onGroopitUpdated(followUpResponse.groopit);
          onClose();
        } else {
          setErrors(followUpResponse.errors);
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        {isLinkedToSalesforce && <SalesforceEditAuthenticator />}
        {errors && (
          <>
            <p>Please correct any errors below and try again.</p>
            {/* Display any errors that aren't tied to a component. */}
            <ul className="text-danger">
              {Object.keys(errors.modelState)
                .flatMap((name) =>
                  errors.modelState[name].map((message) => {
                    return { key: name, message: message };
                  }),
                )
                .filter((error) => !error.key.startsWith("Components["))
                .map((error) => (
                  <li key={`${error.key}-${error.message}`}>{error.message}</li>
                ))}
            </ul>
          </>
        )}
        {componentModels.map((model, i) => (
          <Fragment key={model.componentModel_Id}>
            {i > 0 && <hr className="small-divider" />}
            <GroopitComponentEditor
              model={model}
              baseName={`Components[${i}]`}
              groupId={groupId}
              component={componentDatas.find(
                (c) => c.model.componentModel_Id == model.componentModel_Id,
              )}
              tags={tags}
              errors={
                errors
                  ? Object.keys(errors.modelState)
                      .filter((key) => key.startsWith(`Components[${i}]`))
                      .flatMap((key) => errors.modelState[key])
                  : []
              }
            />
          </Fragment>
        ))}
      </div>
      <div className="flex align-items-start">
        <div className="flex-grow"></div>
        <button type="button" onClick={onClose} className="btn btn-secondary">
          Cancel
        </button>
        <input
          type="submit"
          value="Share"
          className="btn btn-accent btn-progress mr-0"
        />
      </div>
    </form>
  );
};
